import haloLogo from 'images/annotationsProviders/halo.png';
import imagescopeLogo from 'images/annotationsProviders/imageScope.png';
import visiopharmLogo from 'images/annotationsProviders/visiopharm.png';
import qupathLogo from 'images/annotationsProviders/quPath.png';

export const ANNOTATION_PROVIDERS = [
  {
    name: 'Halo',
    provider: 'halo',
    icon: haloLogo,
  },
  {
    name: 'ImageScope',
    provider: 'imagescope',
    icon: imagescopeLogo,
  },
  {
    name: 'Visiopharm',
    provider: 'visiopharm',
    icon: visiopharmLogo,
  },
  {
    name: 'QuPath',
    provider: 'qupath',
    icon: qupathLogo,
  },
];
